import {gql} from 'react-apollo';

const UPDATE_PROFILE = gql`mutation updateUserProfile($firstName: String, $lastName: String, $companyName: String!,
	$phone: String, $position: String, $site: String, $country: String, $address: String, $industry: String, $business: String) {
	data: updateUserProfile(firstName: $firstName, lastName: $lastName, companyName: $companyName,
											phone: $phone, position: $position, site: $site, address: $address, industry: $industry,
											country: $country, business: $business){
												profile {
													id
													companyName
													user {
														firstName
														lastName
													}
													phone
													country
													position
													site
													country
													address
													industry
													business
												}
											}
}`;

export const UPDATE_PASSWORD = gql`mutation updatePassword($currentPassword: String!, $password: String!,
			$confirmPassword: String){
				data: updatePassword(currentPassword: $currentPassword, password: $password, confirmPassword: $confirmPassword){
					success
					error
				}
	}`;

export const READ_MESSAGE = gql`mutation ReadMessage($ids: [Int]!) {
  readMessageByUser(messagesId: $ids) {
    result{
      id
      success
    }
  }
}`;

export default UPDATE_PROFILE;


// WEBPACK FOOTER //
// ./src/components/dashboard/profile/gql/mutation.js